import React from 'react';
import { Refresh } from '@mui/icons-material';
import '@/assets/animations.css';

interface HeaderNotificationProps {
  show: boolean;
  message: string;
  onReload: () => void;
  onDismiss?: () => void;
}

const HeaderNotification: React.FC<HeaderNotificationProps> = ({
  show,
  message,
  onReload,
  onDismiss
}) => {
  if (!show) return null;

  const handleClick = () => {
    onReload();
    onDismiss?.();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div className="fixed top-3 left-[45%] transform -translate-x-1/2 z-50 animate-fadeIn">
      <button
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        className="bg-gradient-to-r from-green-500 to-blue-600 text-white px-6 py-3 rounded-full shadow-xl border border-green-400/30 flex items-center gap-3 transition-all duration-300 hover:shadow-2xl cursor-pointer hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        aria-label={`${message} - Click to reload`}
      >
        <Refresh className="w-4 h-4" />
        <span className="text-sm font-medium">{message}</span>
      </button>
    </div>
  );
};

export default HeaderNotification;
